/** Бизнес (partner-web) порталын суурь URL — .env дээр NEXT_PUBLIC_PARTNER_WEB_URL */
export function getPartnerPortalUrl() {
  const raw =
    (typeof process !== "undefined" && process.env.NEXT_PUBLIC_PARTNER_WEB_URL?.trim()) || "";
  if (raw) return raw.replace(/\/+$/, "");
  // Dev: заагаагүй бол partner-web :3001
  if (typeof process !== "undefined" && process.env.NODE_ENV === "development") {
    return "http://localhost:3001";
  }
  return "";
}
